<div class="terms">
  <img class="logo" src="/img/large-logo.png">
  <div class="form-container">
    <div class="terms-container">
      <h1 [translate]="'TermsTitle'">
        Terms & Conditions
      </h1>
      <p *ngIf="terms; else loadingTerms" [innerHTML]="terms">
      </p>
      <ng-template #loadingTerms>
        <mat-progress-bar mode="buffer"></mat-progress-bar>
      </ng-template>
    </div>
  </div>
</div>